import React from 'react';

import { SVGComponentProps } from './svg.types';

const OnboardingFileSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <rect
          x="0.6"
          y="1.1"
          width="46.8"
          height="46.8"
          rx="9"
          stroke="#E5E7EB"
          strokeWidth="1.2"
        />
        <rect x="4.80029" y="5.2998" width="38.4" height="38.4" rx="4.8" fill="#EBF1FF" />
        <path
          d="M33.0169 20.4917C33.4148 21.0583 32.9405 21.75 32.2482 21.75H15C14.4477 21.75 14 21.3023 14 20.75V18.92C14 16.48 15.98 14.5 18.42 14.5H20.74C22.37 14.5 22.88 15.03 23.53 15.9L24.93 17.76C25.24 18.17 25.28 18.22 25.86 18.22H28.65C30.4546 18.22 32.0516 19.1171 33.0169 20.4917Z"
          fill={fill}
        />
        <path
          d="M33.9834 24.2463C33.9815 23.6953 33.5343 23.2496 32.9834 23.2497L15 23.25C14.4477 23.25 14 23.6977 14 24.25V29.15C14 32.1 16.4 34.5 19.35 34.5H28.65C31.6 34.5 34 32.1 34 29.15L33.9834 24.2463ZM26.5 29.25H24.81V31C24.81 31.41 24.47 31.75 24.06 31.75C23.64 31.75 23.31 31.41 23.31 31V29.25H21.5C21.09 29.25 20.75 28.91 20.75 28.5C20.75 28.09 21.09 27.75 21.5 27.75H23.31V26C23.31 25.59 23.64 25.25 24.06 25.25C24.47 25.25 24.81 25.59 24.81 26V27.75H26.5C26.91 27.75 27.25 28.09 27.25 28.5C27.25 28.91 26.91 29.25 26.5 29.25Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default OnboardingFileSVG;
